const font = {
  sizeXXSmall: '10px',
  sizeXSmall: '12px',
  sizeSmall: '14px',
  sizeMedium: '16px',
  sizeLarge: '18px',
  sizeXLarge: '24px'
} as const;

const iconSize = {
  small: 18,
  medium: 24,
  large: 40
} as const;

const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700
} as const;

const spacingSize = {
  xs: '2px',
  s: '4px',
  m: '8px',
  ml: '12px',
  l: '16px',
  xl: '24px',
  xxl: '32px'
} as const;

export const appTheme = {
  defaultFontSize: font.sizeMedium,
  smallFontSize: font.sizeSmall,
  xSmallFontSize: font.sizeXSmall,
  xxSmallFontSize: font.sizeXXSmall,
  appFontFamily: "'Roboto', 'Helvetica Neue', 'Helvetica', Arial, sans-serif",
  font,
  fontWeights,
  spacingSize,
  iconSize
} as const;
export default appTheme;
